import { evaluateCondition } from './evaluateCondition';
import { generateFallbackStep } from './generateFallbackStep';
import { getCurrentStep } from './getCurrentStep';

export const resolveStepFromGlobalPrerequisite = (flowConfig, props) => {
  if (!flowConfig.globalPrerequisites) {
    return false;
  }

  return flowConfig.globalPrerequisites
    .filter(config => !evaluateCondition(config.prerequisite, props))
    .map(config => ({
      id: `failed-global-prerequisite/${config.back}`,
      path: config.back,
      prerequisite: true,
      isFallback: true,
    }))
    .shift();
};

export const resolveStepFromPrerequisites = (flowConfig, props, stepFromPath) => {
  const globalPrerequisiteStep = resolveStepFromGlobalPrerequisite(flowConfig, props);

  if (globalPrerequisiteStep) {
    return globalPrerequisiteStep;
  }

  // to avoid relying on defaulting to the first step when a URL is not found we can add
  // a dummy step that just skips to the next one just for the sake of better routing,
  // for example '/enable-payouts' returns a whole flow on it's own, but contains a dummy
  // step to match that route since the flow actually starts with the UBO
  let step = stepFromPath;
  while (step.skip && evaluateCondition(step.skip, props)) {
    step = getCurrentStep(flowConfig, props, { pathOverride: step.next });
  }

  // check if the prerequisites for the currentStepAccordingToPath are met
  // if they are not, then we will set the "step" variable to the "back" property
  // and do that until we find a step that matches
  let prerequisite = evaluateCondition(step.prerequisite, props);

  while (
    (step && step.back && !prerequisite) ||
    (step && step.skip && evaluateCondition(step.skip, props))
  ) {
    if (step.skip && evaluateCondition(step.skip, props)) {
      step = getCurrentStep(flowConfig, props, { pathOverride: step.back });
      continue;
    }

    let backPath = '';
    if (Array.isArray(step.back)) {
      backPath = step.back
        .filter(backConfig => evaluateCondition(backConfig.condition, props))
        .map(backConfig => backConfig.path)
        .shift();
    } else {
      backPath = step.back;
    }

    step = getCurrentStep(flowConfig, props, {
      pathOverride: backPath && backPath.length ? backPath : flowConfig.steps[0].back,
    });
    prerequisite = step && evaluateCondition(step.prerequisite, props);
  }

  step = step || generateFallbackStep(flowConfig, props);

  return step;
};
